import React from "react";
import {Navigate} from "react-router-dom";
import {Loader, middleware, RouteType} from "shared/utils/RouteUtiles";
import ApplyEstimationSelect from "../pages/Apply/Estimation/ApplyEstimationSelect";
import {EquipmentRoutes} from "./EquipmentRoutes";

export const MainRoutes: RouteType[] = [
  {
      index: true,
      path: '/tsp',
    element: (
      <Loader
        route={middleware(
          {
            label: 'Home',
            layout: 'basic',
            element: React.lazy(() => import('../pages/Home')),
          },
          []
        )}
      />
    ),
  },
  {
  path: '/tsp/Apply/Estimation/ApplyEstimation/:id',
    label: '장비견적신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Estimation/ApplyEstimation/ApplyEstimation")),
          },
          [] // 상세 화면은 비회원도 접근 가능
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Estimation/ApplyEstimation/:id',
    label: '장비견적신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Estimation/ApplyEstimation/ApplyEstimation")),
          },
          [] // 상세 화면은 비회원도 접근 가능
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Estimation/ApplyEstimation/:id',
    label: '장비견적신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Estimation/ApplyEstimation/ApplyEstimation")),
          },
          [] // 상세 화면은 비회원도 접근 가능
        )}
      />
    ),
  },
  {
    path: '/tsp/About/Notice/:id',
    label: '',
    element: (
      <Loader
        route={middleware(
          {
            label: 'dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/About/Notice/AboutNoticeDetail/AboutNoticeDetail")),
          },
          []
        )}
      />
    ),
  },
  {
    path: '/tsp/About/Inquiry/Detail/:id',
    label: '1:1 문의관리',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AboutInquiryDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/About/Inquiry/AboutInquiryDetail")),
          },
          []
        )}
      />
    ),
  },
  {
    path: '/tsp/About/Inquiry/Write',
    label: '문의 등록',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AboutInquiryWrite',
            layout: 'basic',
            element: React.lazy(() => import("../pages/About/Inquiry/AboutInquiryWrite")),
          },
          ['auth']
        )}
      />
    ),
  }, {
    path: '/tsp/Info',
    label: '실증장비소개',
    element: <Navigate to="/tsp/Info/Equipment" replace />,
  }, {
    path: '/tsp/Info/Equipment',
    label: '실증장비소개',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Info/Equipment/InfoEquipment")),
          },
          []
        )}
      />
    ),
  }, {
    path: '/tsp/Info/Equipment/:id',
    label: '실증장비소개',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Info/Equipment/EquipmentDetail")),
          },
          []
        )}
      />
    ),
  }, {
    path: '/tsp/Info/Equipment/Car',
    label: '자동차',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipmentCar',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Info/Equipment/InfoEquipmentCar")),
          },
          []
        )}
      />
    ),
  }, {
    path: '/tsp/Info/Equipment/Energy',
    label: '자동차',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipmentCar',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Info/Equipment/InfoEquipmentEnergy")),
          },
          []
        )}
      />
    ),
  }, {
    path: '/tsp/Info/Equipment/HealthCare',
    label: '자동차',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipmentCar',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Info/Equipment/InfoEquipmentHealthCare")),
          },
          []
        )}
      />
    ),
  }, {
    path: '/tsp/About/FAQ/:id',
    label: '자주묻는질문',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AboutFAQDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/About/FAQ/AboutFAQDetail")),
          },
          []
        )}
      />
    ),
  },   {
    path: '/tsp/Mypage/Dashboard',
    label: '대쉬보드',
    element: (
      <Loader
        route={middleware(
          {
            label: 'Dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Dashboard/Dashboard")),
          },
          ['auth']
        )}
      />
    ),
  }, {
    path: '/tsp/Mypage/Estimation/MyPageEstimationDetail/:id',
    label: '견적요청상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Estimation/MyPageEstimationDetail")),
          },
          ['auth']
        )}
      />
    ),
  }, {
    path: '/tsp/Mypage/Estimation/UseEstimationModify/:id',
    label: '견적요청수정',
    element: (
      <Loader
        route={middleware(
          {
            label: 'UseEstimationModify',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Estimation/UseEstimationModify")),
          },
          ['auth']
        )}
      />
    ),
  }, {
    path: '/tsp/Apply/Estimation/:id',
    label: '견적신청장비상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'ApplyEstimationDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Estimation/ApplyEstimationSelect")),
          },
          ['auth']
        )}
      />
    )
  },
  {
    path: '/tsp/Apply/Analysis',
    label: '분석환경이용신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'ApplyAnalysis',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/AnlysEnv/AnlysEnvApply")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Analysis',
    label: '분석환경이용 목록',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AnalysisList',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/AnlysEnv/MyPageAnlysEnv")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Analysis/Detail/:id',
    label: '분석환경이용 상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AnalysisDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/AnlysEnv/MyPageAnlysEnvDetail")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Analysis/Modify/:id',
    label: '분석환경이용 수정',
    element: (
      <Loader
        route={middleware(
          {
            label: 'AnalysisModify',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/AnlysEnv/MyPageAnlysEnvModify")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Resource/MyPageResourceDetail/:id',
    label: '컴퓨팅자원사용상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Resource/MyPageResourceDetail")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Resource/ApplyResource',
    label: '컴퓨팅자원사용상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'InfoEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Resource/ApplyResource")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/InquiryDetail/:id',
    label: '마이페이지 1:1 문의관리',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MypageInquiryDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Inquiry/MyPageInquiryDetail")),
          },
          ['auth']
        )}
      />
    ),
  },
  // {
  //   path: '/Font',
  //   label: 'fontTest',
  //   element: (
  //     <Loader
  //       route={middleware(
  //         {
  //           label: 'fontTest',
  //           layout: 'empty',
  //           element: React.lazy(() => import("../pages/Home/Font")),
  //         },
  //         []
  //       )}
  //     />
  //   ),
  // },
  ...EquipmentRoutes,
].map((route: Partial<RouteType>) => ({
  ...route,
  // 개별 route 에 layout 이 지정되어 있으면 그대로 사용하고,
  // 없으면 기본값으로 'space' 레이아웃을 적용
  layout: route.layout ?? 'space',
})) as RouteType[];